import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { openURIInApp } from '../../utils/URLSchemeHelper'

const TermsDetail = () => {
  const intl = useIntl()

  return (
      <div className="d-Agreement">
        <FormattedMessage id='TermsDetail.pageTitle'>
          {(txt) => <h1 className="d-Agreement-pageTitle">{txt}</h1>}
        </FormattedMessage>

        <FormattedMessage id='TermsDetail.title'>
          {(txt) => <h2 className="d-Agreement-title">{txt}</h2>}
        </FormattedMessage>
        <FormattedMessage id='TermsDetail.abstract' />

        <FormattedMessage id='TermsDetail.article1'>
          {(txt) => <h2 className="d-Agreement-title">{txt}</h2>}
        </FormattedMessage>
        <ol className="d-Agreement-list">
          <FormattedMessage id='TermsDetail.paragraph1_1' tagName="li" />
          <FormattedMessage id='TermsDetail.paragraph1_2' tagName="li" />
          <FormattedMessage id='TermsDetail.paragraph1_3' tagName="li" />
        </ol>

        <FormattedMessage id='TermsDetail.article2'>
          {(txt) => <h2 className="d-Agreement-title">{txt}</h2>}
        </FormattedMessage>
        <FormattedMessage id='TermsDetail.paragraph2_1' />

        <FormattedMessage id='TermsDetail.article3'>
          {(txt) => <h2 className="d-Agreement-title">{txt}</h2>}
        </FormattedMessage>
        <FormattedMessage id='TermsDetail.paragraph3_1' />

        <FormattedMessage id='TermsDetail.article4'>
          {(txt) => <h2 className="d-Agreement-title">{txt}</h2>}
        </FormattedMessage>
        <FormattedMessage id='TermsDetail.paragraph4_1' />

        <FormattedMessage id='TermsDetail.article5'>
          {(txt) => <h2 className="d-Agreement-title">{txt}</h2>}
        </FormattedMessage>
        <FormattedMessage id='TermsDetail.paragraph5_1' />

        <FormattedMessage id='TermsDetail.article6'>
          {(txt) => <h2 className="d-Agreement-title">{txt}</h2>}
        </FormattedMessage>
        <ol className="d-Agreement-list">
          <FormattedMessage id='TermsDetail.paragraph6_1' tagName="li" />
          <FormattedMessage id='TermsDetail.paragraph6_2' tagName="li" />
        </ol>

        <FormattedMessage id='TermsDetail.article7'>
          {(txt) => <h2 className="d-Agreement-title">{txt}</h2>}
        </FormattedMessage>
        <ol className="d-Agreement-list">
          <FormattedMessage id='TermsDetail.paragraph7_1' tagName="li" />
          <FormattedMessage id='TermsDetail.paragraph7_2' tagName="li" />
          <FormattedMessage id='TermsDetail.paragraph7_3'>
            {(txt) => (
              <li>
                {txt}
                <ol className="d-Agreement-childList">
                  <FormattedMessage id='TermsDetail.paragraph7_3_1' tagName="li" />
                  <FormattedMessage id='TermsDetail.paragraph7_3_2' tagName="li" />
                  <FormattedMessage id='TermsDetail.paragraph7_3_3' tagName="li" />
                  <FormattedMessage id='TermsDetail.paragraph7_3_4' tagName="li" />
                  <FormattedMessage id='TermsDetail.paragraph7_3_5' tagName="li" />
                </ol>
              </li>
            )}
          </FormattedMessage>
          <FormattedMessage id='TermsDetail.paragraph7_4' tagName="li" />
        </ol>

        <FormattedMessage id='TermsDetail.article8'>
          {(txt) => <h2 className="d-Agreement-title">{txt}</h2>}
        </FormattedMessage>
        <ol className="d-Agreement-list">
           <FormattedMessage id='TermsDetail.paragraph8_1'>
            {(txt) => (
              <li>
                {txt}
                <ol className="d-Agreement-childList">
                  <FormattedMessage id='TermsDetail.paragraph8_1_1' tagName="li" />
                  <FormattedMessage id='TermsDetail.paragraph8_1_2' tagName="li" />
                  <FormattedMessage id='TermsDetail.paragraph8_1_3' tagName="li" />
                  <FormattedMessage id='TermsDetail.paragraph8_1_4' tagName="li" />
                  <FormattedMessage id='TermsDetail.paragraph8_1_5' tagName="li" />
                  <FormattedMessage id='TermsDetail.paragraph8_1_6' tagName="li" />
                  <FormattedMessage id='TermsDetail.paragraph8_1_7' tagName="li" />
                  <FormattedMessage id='TermsDetail.paragraph8_1_8' tagName="li" />
                  <FormattedMessage id='TermsDetail.paragraph8_1_9' tagName="li" />
                  <FormattedMessage id='TermsDetail.paragraph8_1_10' tagName="li" />
                  <FormattedMessage id='TermsDetail.paragraph8_1_11' tagName="li" />
                  <FormattedMessage id='TermsDetail.paragraph8_1_12' tagName="li" />
                  <FormattedMessage id='TermsDetail.paragraph8_1_13' tagName="li" />
                  <FormattedMessage id='TermsDetail.paragraph8_1_14' tagName="li" />
                </ol>
              </li>
            )}
          </FormattedMessage>
          <FormattedMessage id='TermsDetail.paragraph8_2' tagName="li" />
        </ol>

        <FormattedMessage id='TermsDetail.article9'>
          {(txt) => <h2 className="d-Agreement-title">{txt}</h2>}
        </FormattedMessage>
        <FormattedMessage id='TermsDetail.paragraph9_1' />

        <FormattedMessage id='TermsDetail.article10'>
          {(txt) => <h2 className="d-Agreement-title">{txt}</h2>}
        </FormattedMessage>

        <ol className="d-Agreement-list">
          <FormattedMessage id='TermsDetail.paragraph10_1' tagName="li" />
          <FormattedMessage id='TermsDetail.paragraph10_2'>
            {(txt) => (
              <li>
                {txt}
                <ol className="d-Agreement-childList">
                  <FormattedMessage id='TermsDetail.paragraph10_2_1' tagName="li" />
                  <FormattedMessage id='TermsDetail.paragraph10_2_2' tagName="li" />
                  <FormattedMessage id='TermsDetail.paragraph10_2_3' tagName="li" />
                </ol>
              </li>
            )}
          </FormattedMessage>
          <FormattedMessage id='TermsDetail.paragraph10_3' tagName="li" />
        </ol>

        <FormattedMessage id='TermsDetail.article11'>
          {(txt) => <h2 className="d-Agreement-title">{txt}</h2>}
        </FormattedMessage>
        <ol className="d-Agreement-list">
          <FormattedMessage id='TermsDetail.paragraph11_1' tagName="li" />
          <FormattedMessage id='TermsDetail.paragraph11_2' tagName="li" />
        </ol>

        <FormattedMessage id='TermsDetail.article12'>
          {(txt) => <h2 className="d-Agreement-title">{txt}</h2>}
        </FormattedMessage>
        <ol className="d-Agreement-list">
          <FormattedMessage id='TermsDetail.paragraph12_1' tagName="li" values={{
            groupPolicyLink: <a onClick={() => openURIInApp('https://www.sotetsu.co.jp/privacy-policy/index.html')}><FormattedMessage id="TermsDetail.paragraph12_1_group_policy" /></a>
          }}/>
          <FormattedMessage id='TermsDetail.paragraph12_2' tagName="li" />
          <FormattedMessage id='TermsDetail.paragraph12_3' tagName="li" />
        </ol>

        <FormattedMessage id='TermsDetail.article13'>
          {(txt) => <h2 className="d-Agreement-title">{txt}</h2>}
        </FormattedMessage>
        <ol className="d-Agreement-list">
          <FormattedMessage id='TermsDetail.paragraph13_1' tagName="li" />
          <FormattedMessage id='TermsDetail.paragraph13_2' tagName="li" />
        </ol>

        <FormattedMessage id='TermsDetail.article14'>
          {(txt) => <h2 className="d-Agreement-title">{txt}</h2>}
        </FormattedMessage>
        <FormattedMessage id='TermsDetail.paragraph14_1' />

        <FormattedMessage id='TermsDetail.article15'>
          {(txt) => <h2 className="d-Agreement-title">{txt}</h2>}
        </FormattedMessage>
        <ol className="d-Agreement-list">
          <FormattedMessage id='TermsDetail.paragraph15_1' tagName="li" />
          <FormattedMessage id='TermsDetail.paragraph15_2' tagName="li" />
        </ol>

        <FormattedMessage id='TermsDetail.article16'>
          {(txt) => <h2 className="d-Agreement-title">{txt}</h2>}
        </FormattedMessage>
        <FormattedMessage id='TermsDetail.paragraph16_1'>
          {(txt) => (
            <p>
              {txt}<br/>
              {intl.formatMessage({id: 'TermsDetail.paragraph16_1_ios'})}<br/>
              {intl.formatMessage({id: 'TermsDetail.paragraph16_1_android'})}<br/>
            </p>
          )}
        </FormattedMessage>

        <FormattedMessage id='TermsDetail.article17'>
          {(txt) => <h2 className="d-Agreement-title">{txt}</h2>}
        </FormattedMessage>
        <FormattedMessage id='TermsDetail.paragraph17_1' />

        <FormattedMessage id='TermsDetail.article18'>
          {(txt) => <h2 className="d-Agreement-title">{txt}</h2>}
        </FormattedMessage>
        <FormattedMessage id='TermsDetail.paragraph18_1' />

        <p className="d-Agreement-date">
        {intl.formatMessage({id: 'TermsDetail.signatureName'})}<br />
        {intl.formatMessage({id: 'TermsDetail.signatureDate'})}
      </p>
    </div>
  )
}

export default TermsDetail
